import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    className as _$cn,
} from 'intact';
import {Bubble} from '../bubble';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {
        item,
        index,
        list,
        slotRenderers,
    } = this.get();
    const {
        getBubbleProps,
        getBubbleTypingHandler,
        getBubbleTypingCompleteHandler,
    } = list.bubbleList;
    const {k} = this.config;
    const bubbleProps = getBubbleProps(item, index);
    return _$ce(2, 'div', (
        _$cc(Bubble, {
            'className': _$cn(bubbleProps.className),
            'style': bubbleProps.style,
            'content': bubbleProps.content,
            'placement': bubbleProps.placement,
            'avatar': bubbleProps.avatar,
            'roleName': bubbleProps.roleName,
            'loading': bubbleProps.loading,
            'streaming': bubbleProps.streaming,
            'variant': bubbleProps.variant,
            'shape': bubbleProps.shape,
            'maxWidthString': bubbleProps.maxWidthString,
            'typing': bubbleProps.typing,
            'slotRenderers': slotRenderers,
            'ev-typing': getBubbleTypingHandler(item, index),
            'ev-typingComplete': getBubbleTypingCompleteHandler(item, index)
        })
    ), 2, _$cn(`${k}-bubble-list-item`));
};